import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router'; // import Router and NavigationEnd

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @Output() openSideNavEvent: EventEmitter<any> = new EventEmitter();
  constructor(public router: Router) { }

  ngOnInit() {
  }
  openSideNav() {
    this.openSideNavEvent.emit();
  }

  async scrollOnClick(value) {
    if(value !== 'contact-us') {
      await this.router.navigate(['/']);
    }
    document.getElementById(value).scrollIntoView();
  }
}
